export const toInternalOptions = (options) => options.map((option) => {
    if (option.id) {
        if (option.id.indexOf(' ') >= 0) {
            throw new Error(`The ID [${option.id}] cannot contain spaces.`);
        }
        return Object.assign({}, option);
    }
    return Object.assign(Object.assign({}, option), { id: option.label.replace(' ', '-') });
});
